// PLACEHOLDER FLAGS: [NORTH DALLAS ADDRESS], hours, and all pricing are placeholders — do not publish until Hidden Gym supplies real values.

const SQS = "https://images.squarespace-cdn.com/content/v1/53161049e4b05c4d279f28ab";

// Verified media from the Hidden Gym media plan (source manifest: /app/docs/media-manifest.md)
export const MEDIA = {
  photos: {
    bjjRichardson: "/media/photos/MLS03817.webp",       // #827 BJJ class, verified Richardson room
    bjjRichardsonDetail: "/media/photos/MLS03813.webp",  // #826 same Richardson shoot
    bjjCurrent1: "/media/photos/MLS08535.webp",          // #201 Sept 2026 BJJ — location pending confirmation
    bjjCurrent2: "/media/photos/MLS08759.webp",          // #205 same 2026 shoot (portrait)
    boxingRichardson: "/media/photos/MLS03143.webp",     // #802 pad training, verified Richardson (portrait)
    boxingNorthDallas: "/media/photos/MLS01409.webp",    // #174 July 2026 pad coaching, North Dallas (portrait)
    muayThaiRichardson: "/media/photos/MLS04681.webp",   // #782 wall-pad training, Richardson (portrait)
    kidsRichardson: "/media/photos/MLS03485.webp",       // #819 youth boxing, verified Richardson (portrait)
    richardsonMats: "/media/photos/MLS06207.webp",       // #840 Richardson mats/cage room
    richardsonExterior: "/media/photos/MLS02988.webp",   // #792
    richardsonWeights: "/media/photos/MLS03021.webp",    // #796
    richardsonTurf: "/media/photos/MLS03402.webp",       // #811
    richardsonLockers: "/media/photos/MLS03420.webp",    // #814
    northDallasMats: "/media/photos/MLS02439.webp",      // #108 2026 mat room
    northDallasBags: "/media/photos/MLS02450.webp",      // #112 Mezger heavy bags
    northDallasWallPads: "/media/photos/MLS02453.webp",  // #113
    northDallasWeights: "/media/photos/MLS02415.webp",   // #100
    northDallasCardio: "/media/photos/MLS02466.webp",    // #117
    northDallasExterior: "/media/photos/MLS05913.webp",  // #81 March 2026 exterior (portrait)
    // Owner-labeled photo set (Tawna, Sept 2026 Dropbox folder)
    aboutGuy: "/media/photos/about-guy.webp",
    guyHeadshot: "/media/photos/guy-headshot.webp",
    audreyHeadshot: "/media/photos/audrey-headshot.webp",
    bjjMain: "/media/photos/bjj-main.webp",
    bjjClass: "/media/photos/bjj-class.webp",
    bjjWomen: "/media/photos/bjj-women.webp",
    boxingMain: "/media/photos/boxing-main.webp",
    kickboxingMain: "/media/photos/kickboxing-main.webp",
    kidsCombat: "/media/photos/kids-combat.webp",
    lionCubsPhoto: "/media/photos/lion-cubs.webp",
    wrestlingMain: "/media/photos/wrestling-main.webp",
    privateLessonsPhoto: "/media/photos/private-lessons.webp",
    richardson1: "/media/photos/richardson-1.webp",
    northDallas1: "/media/photos/north-dallas-1.webp",
  },
  videos: {
    mmaIntro: { src: "/media/videos/mma-intro.mp4", poster: "/media/posters/mma-intro.jpg", duration: "PT2M23S" },
    mmaAd: { src: "/media/videos/mma-ad-16x9.mp4", poster: "/media/posters/mma-ad-16x9.jpg", duration: "PT29S" },
    guyHypeReel: { src: "/media/videos/guy-hype-reel.mp4", poster: "/media/posters/guy-hype-reel.jpg", duration: "PT37S" },
    raenaKickboxing: { src: "/media/videos/raena-kickboxing-reel.mp4", poster: "/media/posters/raena-kickboxing-reel.jpg", duration: "PT33S" },
    richardsonTour: { src: "/media/videos/richardson-tour.mp4", poster: "/media/posters/richardson-tour.jpg", duration: "PT1M30S" },
    northDallasMmaTour: { src: "/media/videos/north-dallas-mma-tour.mp4", poster: "/media/posters/north-dallas-mma-tour.jpg", duration: "PT19S" },
    northDallasFullTour: { src: "/media/videos/north-dallas-full-tour.mp4", poster: "/media/posters/north-dallas-full-tour.jpg", duration: "PT46S" },
  },
};

export const IMG = {
  hero: MEDIA.photos.bjjRichardson,
  guy: MEDIA.photos.aboutGuy,
  guyHeadshot: MEDIA.photos.guyHeadshot,
  audreyHeadshot: MEDIA.photos.audreyHeadshot,
  amauryHeadshot: "/media/photos/amaury-headshot.webp",
  bjj: MEDIA.photos.bjjRichardsonDetail,
  muayThai: MEDIA.photos.kickboxingMain,
  boxing: MEDIA.photos.boxingMain,
  wrestling: MEDIA.photos.wrestlingMain,
  mma: MEDIA.photos.northDallasBags,
  kids: MEDIA.photos.kidsCombat,
  kids2: `${SQS}/1402492466393-CVSQX3LLWBPPEQV580TB/csckids.jpg`,
  lionCubs: MEDIA.photos.lionCubsPhoto,
  privateLesson: MEDIA.photos.privateLessonsPhoto,
  gymAction1: MEDIA.photos.richardsonMats,
  gymAction2: MEDIA.photos.northDallasMats,
  gymAction3: MEDIA.photos.richardsonWeights,
  gymInterior: MEDIA.photos.northDallasMats,
};

// In this build the Hidden Gym site zone lives under /hiddengym.
// When Hidden Gym's real URLs exist, swap these constants only.
export const HG_TRIAL_PATH = "/hiddengym/martial-arts/free-trial"; // [HIDDEN GYM TRIAL URL]
export const HG_MEMBERSHIP_PATH = "/hiddengym/membership"; // [HIDDEN GYM MEMBERSHIP URL]
export const HG_KIDS_PATH = "/hiddengym/martial-arts/kids"; // [HIDDEN GYM KIDS URL]

// Internal same-site handoff marker (NOT a UTM param — keeps GA4 traffic sources clean).
// Merges the CURRENT query string so genuine inbound utm_*/gclid/fbclid survive the CTA click.
// Optional third arg preselects the trial-form location (allowlisted there).
export const hgLink = (path, campaign, location) => {
  const p = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");
  p.set("hgref", campaign);
  if (location) p.set("location", location);
  // No explicit location: keep any existing ?location= so a chosen gym stays chosen (form allowlists it).
  return `${path}?${p.toString()}`;
};

export const trackConversion = (name, params = {}) => {
  if (window.gtag) window.gtag("event", name, { ...params, transport_type: "beacon" });
};

export const trackPhoneClick = (locationSlug, phoneHref) =>
  trackConversion("phone_click", { location: locationSlug, destination: (phoneHref || "").replace("tel:", "") });

export const trackOutbound = (page, campaign, isTrial = true) => {
  if (window.gtag) {
    window.gtag("event", "outbound_click", {
      event_category: "hidden_gym_handoff",
      event_label: `${page}:${campaign}`,
      transport_type: "beacon",
    });
    if (isTrial) trackConversion("trial_booking_click", { page, campaign });
  }
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/track/trial-click`;
    navigator.sendBeacon?.(url, new Blob([JSON.stringify({ page, campaign })], { type: "application/json" }));
  } catch (e) { /* non-blocking */ }
};

export const LOCATIONS = [
  {
    slug: "richardson",
    name: "Mezger Martial Arts at Hidden Gym Richardson",
    short: "Richardson",
    address: "235 N Central Expy, Richardson, TX 75080",
    street: "235 N Central Expy",
    city: "Richardson",
    zip: "75080",
    phone: "(855) 204-0004",
    phoneHref: "tel:+18552040004",
    hours: "Mon–Fri 6 AM–10 PM · Sat 7 AM–8 PM · Sun 8 AM–8 PM",
    hoursSpec: [
      { days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "06:00", closes: "22:00" },
      { days: ["Saturday"], opens: "07:00", closes: "20:00" },
      { days: ["Sunday"], opens: "08:00", closes: "20:00" },
    ],
    parking: "Free surface lot directly in front of the building.",
    mapEmbed: "https://www.google.com/maps?q=235+N+Central+Expy,+Richardson,+TX+75080&output=embed",
    mapLink: "https://www.google.com/maps/search/?api=1&query=235+N+Central+Expy+Richardson+TX+75080",
    geo: { lat: 32.9545, lng: -96.7357 },
    rating: { value: 4.9, count: 461 },
    programs: ["muay-thai-kickboxing", "boxing", "brazilian-jiu-jitsu", "wrestling", "mma", "kids-martial-arts", "lion-cubs", "private-lessons"],
  },
  {
    slug: "north-dallas",
    name: "Mezger Martial Arts at Hidden Gym North Dallas",
    short: "North Dallas",
    address: "17390 Preston Rd, Ste 360, Dallas, TX 75252",
    street: "17390 Preston Rd, Ste 360",
    city: "Dallas",
    zip: "75252",
    phone: "(817) 730-6787",
    phoneHref: "tel:+18177306787",
    hours: "Mon–Fri 5 AM–10 PM · Sat 7 AM–8 PM · Sun 8 AM–8 PM",
    hoursSpec: [
      { days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "05:00", closes: "22:00" },
      { days: ["Saturday"], opens: "07:00", closes: "20:00" },
      { days: ["Sunday"], opens: "08:00", closes: "20:00" },
    ],
    parking: "Free parking in the Preston Road shopping center lot.",
    mapEmbed: "https://www.google.com/maps?q=17390+Preston+Rd+Ste+360,+Dallas,+TX+75252&output=embed",
    mapLink: "https://www.google.com/maps/search/?api=1&query=17390+Preston+Rd+Ste+360+Dallas+TX+75252",
    geo: { lat: 32.9976, lng: -96.8035 },
    rating: { value: 5.0, count: 102 },
    programs: ["muay-thai-kickboxing", "boxing", "brazilian-jiu-jitsu", "mma", "kids-martial-arts", "private-lessons"],
  },
];

export const STATS = [
  { value: 30, suffix: "+", label: "Years Coaching" },
  { value: 4.9, suffix: "★", label: "Across 580+ Google Reviews", decimals: 1 },
  { value: 2, suffix: "", label: "North Texas Locations" },
  { value: 5, suffix: "+", label: "Ages 5 to Adult" },
];

export const SOCIAL = {
  facebook: "https://facebook.com/hiddengymtx",
  instagram: "https://instagram.com/hidden_gym",
};

export const GOOGLE_REVIEWS_LINK = "https://www.google.com/maps/search/?api=1&query=Mezger%20Martial%20Arts%20at%20Hidden%20Gym%20235%20N%20Central%20Expy%2C%20Richardson%2C%20TX%2075080&query_place_id=ChIJh-47Fi4hTIYRYYNzEDkv3do";

export const GM_NAV = [
  { label: "Programs", to: "/programs" },
  { label: "Schedule", to: "/schedule" },
  { label: "Coaches", to: "/coaches" },
  { label: "Locations", to: "/locations" },
  { label: "About Guy", to: "/about" },
  { label: "Membership", to: "/membership" },
  { label: "FAQs", to: "/faqs" },
];

export const HG_NAV = [
  { label: "Martial Arts", to: "/hiddengym/martial-arts" },
  { label: "Richardson", to: "/hiddengym/martial-arts/richardson" },
  { label: "North Dallas", to: "/hiddengym/martial-arts/north-dallas" },
  { label: "Kids", to: "/hiddengym/martial-arts/kids" },
  { label: "Membership", to: "/hiddengym/membership" },
];
